/* eslint-disable no-console */

import axios from 'axios';

import {upstreamKey} from '../../../components/Forms/Constants/IP/UpstreamKeyLabel';
import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {tableAPIMethod, getRouteIP} from '../../utils/tableAPIMethod';

const supplierInfo = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.supplierInfo}${
        data === 'company' ? '/company' : ''
      }/${getRouteIP(type, id)}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ? (data === 'company' ? {} : data) : {}
    });

    if (type === APITypeEnum.GET_ALL) {
      const mainRes =
        data === 'company'
          ? response.data.data.data.map((item: any) => {
              const innerItem = item?.data.map((item: any) => {
                return item?.coordinates;
              });

              return {
                ...item,
                [upstreamKey.COORDINATES]:
                  innerItem.length > 0
                    ? innerItem
                    : [18.514501374323316, 73.8500025750682]
              };
            })
          : response.data.data.map((item: any) => {
              return {
                ...item,
                [upstreamKey.COORDINATES]:
                  item?.[upstreamKey.COORDINATES].length > 0
                    ? item?.[upstreamKey.COORDINATES]
                    : [18.514501374323316, 73.8500025750682]
              };
            });

      return mainRes;
    } else {
      return response.data;
    }
  } catch (err: any) {
    const data = err?.response?.data;
    const message = data?.message || 'Something went wrong';
    const reloadSubscription = data?.reloadSubscription === true;
    const reloadType = data?.reloadType;

    return {status: 'error', message, reloadSubscription, reloadType};
  }
};

export default supplierInfo;
